import React from 'react'

import { useState, useMemo, useRef, useCallback } from 'react'

import { v4 as uniqid } from 'uuid'

import { HiOutlineExclamation } from 'react-icons/hi'

import bemit from '@function/bemit'

import { isTrue } from '@root/utility'

export default function CheckboxEl ({ onChange, ...props })
{
	const [id, setId] = useState(uniqid());
	const ref = useRef();

	const is__disabled = isTrue(props['read-only']);

	const modifiers = useMemo(function ()
	{
		const modifiers = [].concat(props.bemit || []);

		if (props.checked) modifiers.push('checked');
		if (is__disabled) modifiers.push('disabled');
		if (props.error && props.show_error) modifiers.push('error');
		if (props.required) modifiers.push('required');
		if (!props.label) modifiers.push('no-label');

		return modifiers;
	},
	[props.checked, is__disabled, props.bemit, props.error, props.show_error, props.required, props.label]);

	const handleClick = useCallback(function (e)
	{
	// permet d'éviter de focus l'input lorsqu'il s'agit d'un clic souris
	// et pas espace/enter (il n'y a pas de façon de savoir si c'est un click souris)
	// et mousedown/up sont exclus (la checkbox se coche après)
		if (e.target !== ref.current)
		{
			e.preventDefault();

			ref.current?.blur?.();

			onChange(e, props.name);
		}
	},
	[onChange, props.name]);

	return (
		<label className={ bemit('c-checkbox', modifiers) } htmlFor={ id }
			onClick={ is__disabled ? undefined : handleClick }>

			{
				props['left-label'] ?
				(
					<span className={
							bemit('c-form-element-label',
								modifiers.concat(['checkbox', 'checkbox-left'])
							)
						}>
						{ props['left-label'] }
					</span>
				)
				: undefined
			}

			<input type="checkbox" checked={ props.checked } id={ id }
				onChange={ onChange }
				ref={ ref }
				disabled={ is__disabled }
			/>

			<div className="c-checkbox__indicator" />

			<span className={
					bemit('c-form-element-label', modifiers.concat(['checkbox']))
				}>
				{ props.label }
			</span>

			{
				props.show_error && props.error ?
				(
					<span className={ bemit('c-field-error', ['checkbox']) }>
						<HiOutlineExclamation className="c-field-error__icon" />
						{ props.error }
					</span>
				)
				: undefined
			}
		</label>
	);
}